import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { formatUsd } from "@/lib/format";

interface Props {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  usdCost?: number;
  insufficientBalance?: boolean;
  label?: string;
  loadingLabel?: string;
  className?: string;
}

export function GenerateButton({
  onClick,
  disabled,
  loading,
  usdCost,
  insufficientBalance,
  label = "Generate",
  loadingLabel = "Preparing…",
  className,
}: Props) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled || insufficientBalance}
      loading={loading}
      size="lg"
      className={cn("w-full", className)}
    >
      {!loading && <Sparkles className="h-4 w-4" />}
      {loading ? loadingLabel : label}
      {!loading && usdCost != null && usdCost > 0 && (
        <span className="ml-1 rounded-md bg-black/15 px-2 py-0.5 font-mono text-xs">
          {insufficientBalance ? "Insufficient" : (formatUsd(usdCost) ?? "—")}
        </span>
      )}
    </Button>
  );
}
